"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockKitIntent = void 0;
const season_group_1 = require("./season_group");
const species_1 = require("./species");
const state_1 = require("./state");
const technique_1 = require("./technique");
const waterbody_1 = require("./waterbody");
function mockKitIntent(overrides = {}) {
    return {
        id: 1,
        kit_products: [],
        season_group: (0, season_group_1.mockSeasonGroup)(),
        species: (0, species_1.mockSpecies)(),
        state: (0, state_1.mockStateDetail)(),
        technique: (0, technique_1.mockTechnique)(),
        waterbody: (0, waterbody_1.mockWaterbodyDetail)(),
        ...overrides,
    };
}
exports.mockKitIntent = mockKitIntent;
